var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgButtonArrow = function SvgButtonArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 10,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M.506 5.009c0 .569.462 1.03 1.031 1.03h11.949l-1.678 1.678a1.03 1.03 0 1 0 1.458 1.458l3.437-3.438a1.03 1.03 0 0 0 0-1.457L13.266.842A1.032 1.032 0 1 0 11.808 2.3l1.678 1.677H1.537A1.03 1.03 0 0 0 .506 5.01",
    clipRule: "evenodd"
  })));
};
export default SvgButtonArrow;